export default "__VITE_PUBLIC_ASSET__69f69033__"